<div class="flex flex-row justify-around items-center">

  <a mat-raised-button routerLink="/make-call">Make Call</a>

  <a mat-raised-button routerLink="/send-message">Send Message</a>

</div>
